<template>
    <kgr-generic-select
        ref="dropdown"
        display="display"
        :value="selectedMember"
        :label="label"
        :options="uniqueMembers"
        :loading="loading"
        :inline="inline"
        @post-input="onInput"
    />
</template>

<script>
import GenericSelect from './GenericSelect.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
    },
    props: {
        memberId: {
            type: Number,
            required: true,
        },
        value: {
            type: [Number, Object],
            required: false,
            default: null,
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        includeSelf: {
            type: Boolean,
            required: false,
            default: true,
        },
        defaultMemberId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            members: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('club.memberRelations');
        },
        uniqueMembers() {
            return Array.from(
                new Map(this.members.map((item) => [item.id, item])).values(),
            );
        },
        selectedMember() {
            if (typeof this.value === 'object') {
                return this.value;
            }
            return this.members.find((m) => m.id === this.value);
        },
    },
    watch: {
        value() {
            this.setSelected();
        },
    },
    created() {
        this.loadMemberRelations();
    },
    methods: {
        loadMemberRelations() {
            this.loading = true;
            axios
                .get(`/club/members/${this.memberId}/relations`)
                .then((response) => {
                    axios
                        .get(`/club/members/${this.memberId}`)
                        .then((innerResponse) => {
                            const member = {
                                id: innerResponse.data.data.id,
                                firstName: innerResponse.data.data.firstName,
                                lastName: innerResponse.data.data.lastName,
                                academicTitle: innerResponse.data.data.academicTitle,
                                display: this.getItemText(innerResponse.data.data),
                            };
                            const membersA = response.data.data.map((relation) => {
                                return {
                                    id: relation.memberA.id,
                                    firstName: relation.memberA.firstName,
                                    lastName: relation.memberA.lastName,
                                    academicTitle: relation.memberA.academicTitle,
                                    disabled: relation.memberA.hasDefaultInvoiceReceiver && relation.memberA.id !== member.id,
                                    display: this.getItemText(relation.memberA),
                                };
                            });
                            const membersB = response.data.data.map((relation) => {
                                return {
                                    id: relation.memberB.id,
                                    firstName: relation.memberB.firstName,
                                    lastName: relation.memberB.lastName,
                                    academicTitle: relation.memberB.academicTitle,
                                    disabled: relation.memberB.hasDefaultInvoiceReceiver && relation.memberB.id !== member.id,
                                    display: this.getItemText(relation.memberB),
                                };
                            });

                            this.members = membersA.concat(membersB);
                            this.members.push(member);

                            if (!this.includeSelf) {
                                const memberId = this.memberId;
                                this.members = this.members.filter((item) => {
                                    return item.id !== memberId;
                                });
                            }
                            this.setSelected();
                            this.loading = false;
                        });
                });
        },
        getItemText(item) {
            let text = `${item.firstName} ${item.lastName}`;
            if (item.academicTitle && item.academicTitle.data) {
                text = `${item.academicTitle.data.value} ${text}`;
            }
            if (this.defaultMemberId === item.id) {
                text += ' (Standard)';
            }
            return text;
        },
        setSelected() {
            if (this.value === null) {
                return;
            }

            const id = typeof this.value === 'object' ? this.value.id : this.value;
            const selected = this.uniqueMembers.find((m) => m.id === id);

            if (selected) {
                this.$emit('input', selected);
                this.$nextTick(() => {
                    this.$emit('post-input', selected);
                });
            }
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
